import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectProgramIndexTypes = createSelector(
  getProgramsCategory,
  ({ programIndexTypes }) => programIndexTypes,
);

const selectProgramIndexTypesValues = createSelector(selectProgramIndexTypes, Object.values);

export const selectProgramIndexTypesOptions = createSelector(
  selectProgramIndexTypes,
  programIndexTypes =>
    Object.values(programIndexTypes)?.map(({ name, indexTypeId }) => ({
      name,
      value: indexTypeId,
    })),
);

export const selectFilteredProgramIndexTypes = createSelector(
  [getDebouncedSearchValue, selectProgramIndexTypesValues],
  searchItems(({ name, ricCode }) => [name, ricCode]),
);
